/**
 * 실험 #316 - /match/request 온보딩 A/B (구 #312 후속, 모수 확대판).
 * "장례 비용이 궁금할 유저가 누를 CTA"를 통해 진입한 경우만 실험 대상으로 삼는다.
 *
 * 할당 구조(헤더와 동일): CTA 클릭 시 markEligible() → /match/request 이동 →
 * MatchRequestContainer가 자격 유저만 ABEnabledContainer(316)를 마운트해 노출/할당.
 *
 * 자격 마킹 지점: 헤더 네비 "장례견적", 홈 "장례 비용 알아보기" / "장례 예상 견적 계산하기",
 * InfoPageCrmFixedCta("장례 견적 받기" — 가이드북·상품·임종준비·후기 공유),
 * GuidebookTipBottomFixedButtonSection(가이드북 tip 개별 콘텐츠).
 */
const ELIGIBLE_KEY = "match_request_316_eligible";

/** CTA 클릭 시점에 실험 자격을 마킹한다(존재 여부만 의미, 값은 무의미). */
export const markMatchRequestOnboardingEligible = () => {
  if (typeof window === "undefined") return;
  sessionStorage.setItem(ELIGIBLE_KEY, "1");
};

/** 자격 플래그 존재 여부. sessionStorage는 클라이언트 전용이라 mount 이후 호출한다. */
export const isMatchRequestOnboardingEligible = () =>
  typeof window !== "undefined" && sessionStorage.getItem(ELIGIBLE_KEY) !== null;
